module.exports = __webpack_public_path__ + "img/qrcode2.64eeede8.svg";